import { mergeClasses } from '@/utils';

interface ILoading {
  fullScreen?: boolean;
  className?: string;
}

export const Loading = ({ fullScreen, className }: ILoading) => {
  return (
    <div
      className={mergeClasses(
        'inset-0 flex flex-col items-center justify-center bg-opacity-light-70 z-[100]',
        fullScreen ? 'fixed' : 'absolute',
        className,
      )}
    >
      <span className="w-12 h-12 shrink-0 border-[5px] border-primary-base border-b-transparent rounded-full inline-block box-border animate-spin"></span>
      <span className="font-semibold text-body-base text-neutral-9">Loading...</span>
    </div>
  );
};
